import { getWidthMetrics } from './getWidthMetrics';
import type { Chart } from './types';

// Single source of truth for the metrics a chart has to ask the backend for:
// the two plotted ones plus whatever the axes size their lines by. The request
// and the refetch cache key both derive from here, so a width metric can never
// end up requested without invalidating the cached data — or vice versa.
export const getRequestedMetrics = (config: Chart): string[] => {
  return [
    ...new Set(
      [
        config.primaryMetric,
        config.secondaryMetric,
        ...getWidthMetrics(config),
      ].filter(Boolean),
    ),
  ];
};
